/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/

import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import { store } from "./store";
import { registerGlobalComponents } from "./global-components";

// Own global mixins
import DateMixin from "./classes/DateMixin";

import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";

const firebaseApp = initializeApp({
  apiKey: "AIzaSyDktLWA1tUXZNSzBwykFB31IzgPLnHu1qU",
  authDomain: "caderio-neu.firebaseapp.com",
  databaseURL: "https://caderio-neu.firebaseio.com",
  projectId: "caderio-neu",
  storageBucket: "caderio-neu.appspot.com",
  messagingSenderId: "854993856946",
  appId: "1:854993856946:web:16f5fd5d52112eb1e51cab",
  measurementId: "G-25QXBLF85L",
});

// initializeApp({
//   projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
//   apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
//   authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
//   databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
//   storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
//   messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
//   appId: process.env.VUE_APP_FIREBASE_APP_ID,
// });

if (process.env.VUE_APP_ENV_VAR === "dev") {
  connectAuthEmulator(getAuth(), process.env.VUE_APP_EMULATOR_AUTH as string, {
    disableWarnings: true,
  });
  connectFirestoreEmulator(
    getFirestore(),
    process.env.VUE_APP_EMULATOR_FIRESTORE_HOST as string,
    parseInt(process.env.VUE_APP_EMULATOR_FIRESTORE_PORT as string)
  );
} else if (process.env.VUE_APP_ENV_VAR === "prod") {
  // import { getAnalytics } from "firebase/analytics"; //TODO only in prod
  // const analytics = getAnalytics(app); //TODO only in prod
}

const app = createApp(App);
registerGlobalComponents(app);

// Register own global mixins
app.use(store).use(router).mount("#app");
app.mixin(DateMixin);

document.title = "ChatCaptain";

// useAuthService(); moved to Router
